import React from 'react';
import PropTypes from 'prop-types';

export default function Partnership({ partnership }) {
  if (!partnership) {
    return (
      <h2>Partnership: None</h2>
    );
  }

  const {
    id,
    name,
    type,
    email,
    isActive,
  } = partnership;

  return (
    <>
      <h2>
        Partnership:&nbsp;
        <a href={`/lwadmin/partnership/${id}/wires`}>
          {name}
        </a>
      </h2>
      <div>
        <strong>Partnership type:&nbsp;</strong>
        <span>{type}</span>
      </div>
      <div>
        <strong>Contact:&nbsp;</strong>
        <span>
          {!!email && <a href={`mailto:${email}`}>{email}</a>}
        </span>
      </div>
      <div>
        <strong>Status:&nbsp;</strong>
        <span>{isActive ? 'Active' : 'Inactive'}</span>
      </div>
    </>
  );
}

Partnership.propTypes = {
  partnership: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string,
    type: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
  }),
};

Partnership.defaultProps = {
  partnership: null,
};
